var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Inset from '../../spacing/Inset';
import Small from '../../typography/Small';
import { AccountDetailsWrapper, DrawerHeaderBase, Image, LogoWrapper, Title, TitleWrapper } from './subcomponents';
import handleImageError from '../../../helpers/handleImageError';
const DrawerHeader = (_a) => {
    var { img, title, subtitle, alt, className, fallbackImage } = _a, props = __rest(_a, ["img", "title", "subtitle", "alt", "className", "fallbackImage"]);
    return (React.createElement(DrawerHeaderBase, Object.assign({ className: className }, props),
        img && (React.createElement(LogoWrapper, null,
            React.createElement(Image, { src: img, alt: alt, onError: (e) => handleImageError(e, fallbackImage) }))),
        React.createElement(AccountDetailsWrapper, null,
            React.createElement(Inset, { horizontal: "xsmall", left: "small", right: "xsmall" },
                React.createElement(TitleWrapper, null,
                    React.createElement(Title, { as: "h2", weight: "bold" }, title)),
                React.createElement(React.Fragment, null, typeof subtitle === 'string' ? (React.createElement(Small, { weight: "light" }, subtitle)) : (subtitle))))));
};
export default DrawerHeader;
